import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    commitHash: process.env.VUE_APP_COMMIT_HASH || 'xxxx',
    version: process.env.VUE_APP_VERSION || 'x.x.x',
    system: process.env.VUE_APP_SYSTEM
  },
  mutations: {

  },
  actions: {

  }
})
